import React from 'react'
import SubHeader from '../general/SubHeader'
import AboutImg from '../assets/banner.png'

const About = () => {
  return (
    <>
      <SubHeader message="About Us" />


{/* About section */}
<section className="about-store py-5">
  <div className="container">

    <div className="row align-items-center">

      <div className="col-lg-6">
        <span className="about-tag">ABOUT OUR STORE</span>

        <h2 className="about-title mt-3">
          Fresh Groceries, Everyday Convenience
        </h2>

        <p className="about-text">
          Grocery Store is your trusted destination for fresh fruits,
          vegetables, dairy products, snacks, beverages, and all your
          daily household essentials. We are committed to providing
          premium quality products at affordable prices.
        </p>

        <p className="about-text">
          Our mission is to make grocery shopping simple, convenient,
          and reliable. With carefully selected products, quick service,
          and customer-first support, we ensure you always receive
          freshness and value in every purchase.
        </p>

<a
  href="https://play.google.com/store/apps/details?id=com.dectwin.satyam_store"
  target="_blank"
  rel="noopener noreferrer"
  className="about-btn text-decoration-none d-inline-block"
>
  Shop Now
</a>


      </div>

      <div className="col-lg-6 mt-4 mt-lg-0">
        <img
          src="https://cdn.pixabay.com/photo/2024/07/10/09/30/grocery-8885334_1280.jpg"
          alt="Grocery Store"
          className="img-fluid about-img"
        />
      </div>

    </div>

  </div>
</section>
{/* About section ends */}


{/* values section */}
<section className="py-5 bg-blue">
  <div className="container">

    <div className="row gy-4">

      <div className="col-lg-4 col-md-6 col-12">
        <div className="service-box">
          <p className="banner-text" style={{ color: 'var(--blue3)' }}>
            <i
  className="fa-solid fa-truck-fast fa-2x me-2"
  style={{ color: 'var(--blue3)' }}
></i>
           {/* <i className="fa-solid fa-truck-fast fa-2x text-success me-2"></i> */}
            Fast Delivery
          </p>

            <p className style={{color:"#fff"}}>
            Get fresh groceries, fruits, vegetables, dairy products and
            daily essentials delivered quickly to your doorstep.
          </p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 col-12">
        <div className="service-box">
          <p className="banner-text" style={{ color: 'var(--blue3)' }}>
            <i className="fa-solid fa-basket-shopping fa-2x me-2"   style={{ color: 'var(--blue3)' }}></i>
            Fresh & Quality Products
          </p>

          <p className style={{color:"#fff"}}>
            We carefully select farm-fresh fruits, vegetables and premium
            grocery essentials to ensure the best quality every day.
          </p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 col-12">
        <div className="service-box">
          <p className="banner-text" style={{ color: 'var(--blue3)' }}>
            <i className="fa-solid fa-headset fa-2x me-2"  style={{ color: 'var(--blue3)' }}></i>
            24×7 Customer Support
          </p>

           <p className style={{color:"#fff"}}>
            Our friendly support team is always available to help with
            orders, delivery updates and any shopping queries.
          </p>
        </div>
      </div>

    </div>

<div className="d-flex justify-content-center mt-5">
  <img
    src={AboutImg}
    className="img-fluid about-banner"
    alt="Fresh Grocery"
  />
</div>
  </div>
</section>
{/* values section ends */}


{/* Testimonial section */}
<section className="my-5">
  <div className="container">

    <p className="sec-heading text-center">What Our Customers Say</p>

    <div
      id="carouselExampleIndicators"
      className="carousel slide col-lg-8 mx-auto"
      data-bs-ride="carousel"
      data-bs-interval="2500"
    >
      <div className="carousel-indicators">
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"></button>
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3"></button>
      </div>

      <div className="carousel-inner pb-5">

        {/* Testimonial 1 */}
        <div className="carousel-item active text-center">
          <p className="text-warning fs-5">
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
          </p>

          <p className="testimonial-text">
            "Fresh vegetables and fruits every time! The quality is excellent,
            prices are reasonable, and delivery is always on time."
          </p>

          <h6 className="mt-3 fw-bold">Rahul Sharma</h6>
        </div>

        {/* Testimonial 2 */}
        <div className="carousel-item text-center">
          <p className="text-warning fs-5">
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
          </p>

          <p className="testimonial-text">
            "Ordering groceries has never been this easy. Everything arrived
            fresh, neatly packed, and exactly as expected."
          </p>

          <h6 className="mt-3 fw-bold">Priya Verma</h6>
        </div>

        {/* Testimonial 3 */}
        <div className="carousel-item text-center">
          <p className="text-warning fs-5">
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
          </p>

          <p className="testimonial-text">
            "Best grocery store in the area. Great discounts, fresh products,
            and friendly customer support. Highly recommended!"
          </p>

          <h6 className="mt-3 fw-bold">Amit Singh</h6>
        </div>

        {/* Testimonial 4 */}
        <div className="carousel-item text-center">
          <p className="text-warning fs-5">
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
            <i className="fa-solid fa-star px-1"></i>
          </p>

          <p className="testimonial-text">
            "Excellent service! Daily essentials are always available and the
            doorstep delivery saves me so much time."
          </p>

          <h6 className="mt-3 fw-bold">Neha Gupta</h6>
        </div>

      </div>
    </div>

  </div>
</section>
{/* Testimonial section ends */}

    </>
  )
}

export default About
